module.exports = __webpack_public_path__ + "static/media/jayesh-shelar.d9c7c15d.jpg";